import { useEffect, useState } from "react";
import { useFavorites } from "@/hooks/useFavorites";

interface FavoriteButtonProps {
  id: string;
  label?: string;
}

export default function FavoriteButton({ id, label = "收藏本集" }: FavoriteButtonProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const [toast, setToast] = useState("");
  const active = isFavorite(id);

  useEffect(() => {
    if (!toast) return;
    const timer = setTimeout(() => setToast(""), 2200);
    return () => clearTimeout(timer);
  }, [toast]);

  const handleClick = () => {
    const nowFavorite = toggleFavorite(id);
    setToast(nowFavorite ? "收藏成功，已保存到本地" : "已取消收藏");
  };

  return (
    <div className="relative inline-flex">
      <button
        type="button"
        onClick={handleClick}
        aria-pressed={active}
        className={`inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md px-5 py-3 font-label text-sm font-semibold transition-colors ${
          active
            ? "bg-accent-500 text-primary-950 hover:bg-accent-400"
            : "border border-background-300 bg-background-50 text-foreground-800 hover:border-accent-300 hover:text-accent-600"
        }`}
      >
        <span className="flex h-4 w-4 items-center justify-center">
          <i className={active ? "ri-bookmark-fill text-base" : "ri-bookmark-line text-base"}></i>
        </span>
        {active ? "已收藏" : label}
      </button>
      {toast && (
        <span className="absolute -top-10 left-0 z-10 whitespace-nowrap rounded-md bg-foreground-950 px-3 py-1.5 text-xs text-background-50 shadow-none">
          {toast}
        </span>
      )}
    </div>
  );
}